module.exports = ":host {\n  display: block;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/examples/large-data-pagination/large-data-pagination.component.css
// module id = ./src/app/examples/large-data-pagination/large-data-pagination.component.css
// module chunks = main